const config = {
    API_BASE: 'https://hdtoldos.com.br/api'
}


export default config